import { styled } from '@/stitches.config';
import { Box } from '@base-app';

export const StyledHeaderContainer = styled(Box, {
  borderBottom: '$borderWidths$1 solid $seafoam',
});

export const StyledHeader = styled('header', {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  margin: 'auto',
  maxWidth: 'calc($studyInsights$containerMaxWidth + $6)',
  padding: '$layoutPadding $0',
  textAlign: 'right',
  verticalAlign: 'baseline',
});
